import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import isFunction from 'lodash/isFunction';

import AirSlider from '../../AirSlider';
import { Button } from "antd";

import './MapRadiusEdit.css';

@inject('translationsStore')
@observer
export default class MapRadiusEdit extends Component {
  increaseRadius = () => {
    if (this.props.maxValue < this.props.value + this.props.stepButton) {
      this.props.onChange(this.props.maxValue);
    } else {
      this.props.onChange(this.props.value + this.props.stepButton);
    }
  }

  decreaseRadius = () => {
    if (this.props.minValue > this.props.value - this.props.stepButton) {
      this.props.onChange(this.props.minValue);
    } else {
      this.props.onChange(this.props.value - this.props.stepButton);
    }
  }

  onChange = radius => {
    if (isFunction(this.props.onChange)) {
      this.props.onChange(radius);
    }
  };

  onApply = () => {
    if (isFunction(this.props.onApply)) {
      this.props.onApply();
    }
  };

  onCancel = () => {
    if (isFunction(this.props.onCancel)) {
      this.props.onCancel();
    }
  };

  render() {
    if (!(this.props.hasOwnProperty('visible') && !this.props.visible)) {
      return (
        <div className={`MapRadiusEdit ${this.props.className || ''}`} style={this.props.style}>
          <Button shape="circle" className={this.props.showStepRadiusButton ? 'StepRadioButton DecreaseRadiusButton' : 'hidden'} 
            onClick={() => {this.decreaseRadius(); }}>-</Button>
          <AirSlider
            horizontal
            className="RadiusSlider"
            visibleMinMax={false}
            value={this.props.value}
            disabled={false}
            min={this.props.minValue}
            max={this.props.maxValue}
            showLocale={true}
            uom="Km"
            onChange={this.onChange}
            step={this.props.step}
            stepAsDivisor={true}
          />
          <Button shape="circle" className={this.props.showStepRadiusButton ? 'StepRadioButton IncreaseRadiusButton' : 'hidden'} 
            onClick={() => {this.increaseRadius(); }}>+</Button>
          <div className={this.props.showApplyButton ? 'Button ButtonApply' : 'hidden'} onClick={this.onApply}>
            {this.props.applyLabel}
          </div>
        </div>
      );
    } else {
      return <Fragment />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/MapMenu/MapRadiusEdit/MapRadiusEdit.js